import { render, staticRenderFns } from "./modalProdInsuficiente.vue?vue&type=template&id=a0b285b4&"
import script from "./modalProdInsuficiente.vue?vue&type=script&lang=js&"
export * from "./modalProdInsuficiente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports